const prescription = {
    searchPrescription: () => `store/prescriptions`,
    sharePrescription:()=>'store/prescriptions/share',
}
export default prescription
